import { registerErrorMessages } from "@getaways/extranet-ui";
import "@getaways/extranet-ui/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./tours.css";

registerErrorMessages({
  not_found: "Not found.",
  invalid_input: (data) => (Array.isArray(data.problems) && data.problems.length ? `${data.message}: ${(data.problems as { field: string; message: string }[]).map((p) => `${p.field.split(".").slice(-1)[0]} ${p.message}`).join("; ")}` : undefined),
  invalid_offer_key: "This price is no longer valid. Price again.",
  supplier_error: "The supplier refused the request.",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
